import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["children", "trigger", "visible"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { PopoverBase } from "../PopoverBase";
import { PopoverArrowStyled, PopoverWrapperStyled } from "./Popover.styles";

var Popover = function Popover(_ref) {
  var children = _ref.children,
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? "click" : _ref$trigger,
      visible = _ref.visible,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(PopoverBase, _extends({
    interactive: true,
    visible: visible
  }, typeof visible === "undefined" && {
    trigger: trigger
  }, props, {
    WrapperComponent: PopoverWrapperStyled,
    ArrowComponent: PopoverArrowStyled
  }), children);
};

export { Popover };